
import Panel from 'vux/src/components/panel/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Previewer from 'vux/src/components/previewer/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'


export default {
components: {
Panel, Previewer, Swiper, SwiperItem, Tab, TabItem
},
directives: {
TransferDom
},
data() {
return {
type: "5",
imglist: []
}
},
methods: {}

}



// WEBPACK FOOTER //
// ./src/components/Home.vue